function escapeRegExp(s) {
    let re = s.replace(/[/\-\\^$+.()|[\]{}]/g, '\\$&');
    re = re.replaceAll('*', '.*');
    re = re.replaceAll('?', '.{1}');
    return re;
}
export function filterRegExp(settings) {
    if (!settings?.text.length) {
        return null;
    }
    let source = settings.useRe ? settings.text : escapeRegExp(settings.text);
    if (settings.wholeWord) {
        source = `^${source}$`;
    }
    try {
        return new RegExp(source, settings.matchCase ? '' : 'i');
    }
    catch {
        return null;
    }
}
const tmpRe = new RegExp('^(?:' +
    String.raw `.*~|` +
    String.raw `.*\.(?:tmp|temp|bak|old|orig|save|swp|swo|swn|part|crdownload|download|dmp|core)|` +
    String.raw `[._].*\.sw[a-z]|` +
    String.raw `.*\.un~|` +
    String.raw `\.#.*|` +
    String.raw `#.*#|` +
    String.raw `\.~.*#|` +
    String.raw `\.goutputstream-.*|` +
    String.raw `\._.*|\.DS_Store|\.Trashes|\.Spotlight-V100|\.fseventsd|\.TemporaryItems|\.DocumentRevisions-V100|Thumbs\.db|ehthumbs\.db|` +
    String.raw `core(?:\..*)?` +
    ')$');
export function buildFilterPredicate(settings) {
    const nameRe = filterRegExp(settings);
    return (name) => {
        if (settings.hidden
            && name.startsWith('.')) {
            return false;
        }
        if (settings.temporary
            && tmpRe.test(name)) {
            return false;
        }
        if (!nameRe) {
            return true;
        }
        const matched = nameRe.test(name);
        return settings.invert ? !matched : matched;
    };
}
